import React from 'react';
import {FluidGrid} from '../../atoms/Grid/Grid';
import {Link} from './Link';

interface LinkSectionProps {
  style?: React.CSSProperties;
  links: {
    href: string;
    label: string;
  }[];
}

export const LinkSection: React.FC<LinkSectionProps> = ({links, ...props}) => {
  return (
    <FluidGrid as="menu" {...props}>
      {links.map((link, index) => (
        <Link link={link} key={index} />
      ))}
    </FluidGrid>
  );
};
